//=====================================================
//　電話番号テキストボックス
//=====================================================

import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";
import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    nameTelPrivate: string
    nameTelFam: string,
}

const FORM_TITLE = "電話番号";
const TEL_PRIVATE_TITLE = "携帯電話番号";
const TEL_FAM_TITLE = "固定電話番号";

export function TxtTel(props: IFProps) {
    
    const cf = useFormContext();

    //バリデーション
    const validationsTelFam = {
        pattern: {value: /^(\d|-)+$/, message: getMsg(ConstMsg.EG0040006, [TEL_FAM_TITLE])},
        validate: {
            requiredCheck: function(){return requiredCheck(props, cf)},
            formatCheck: function(){return formatCheck(props.nameTelFam, cf, ConstMsg.EG0040007)},
            numberCheckFam: function(){return numberCheckFam(props.nameTelFam, cf)},
        },
        maxLength: {value: 13, message: getMsg(ConstMsg.EG0040003, [TEL_FAM_TITLE, "13"])}
    }
    const validationsTelPrivate = {
        pattern: {value: /^(\d|-)+$/, message: getMsg(ConstMsg.EG0040006, [TEL_PRIVATE_TITLE])},
        validate: {
            requiredCheck: function(){return requiredCheck(props, cf)},
            formatCheck: function(){return formatCheck(props.nameTelPrivate, cf, ConstMsg.EG0040014)},
            numberCheckPrivate: function(){return numberCheckPrivate(props.nameTelPrivate, cf)},
        },
        maxLength: {value: 13, message: getMsg(ConstMsg.EG0040003, [TEL_PRIVATE_TITLE, "13"])}
    }


    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.EitherRequired} />
            <ValidErrMsgInline name={props.nameTelPrivate}/>
            {!cf.formState.errors[props.nameTelPrivate] && <ValidErrMsgInline name={props.nameTelFam}/>}
            <div className="input-supple-flex">
                <InputTextBase name={props.nameTelPrivate} className="input-text-phone-number-private" validations={validationsTelPrivate} type="tel"/>
                <InputTextBase name={props.nameTelFam} className="input-text-phone-number" validations={validationsTelFam} type="tel"/>
            </div>
            <div className="input-supple">
                <div className="input-supple-flex">
                    <div className="input-supple-name">携帯</div>
                    <div className="input-supple-name">固定</div>
                </div>
                <div>※半角数字とハイフンのみ</div>
            </div>
        </div>
    )

}

//-----------------------------------------------------
//　ハイフン含む形式チェック
//-----------------------------------------------------
function formatCheck(propsName: string, cf: UseFormReturn<FieldValues>, msg: string){
    //入力にハイフンを含む場合
    //「半角数字-(ハイフン)半角数字-(ハイフン)半角数字」の形式以外を入力した場合エラー
    if (cf.getValues(propsName).indexOf("-") === -1){
        return null;
    }
    const tmpVal = cf.getValues(propsName).match(/^\d+-\d+-\d+$/g);
    if (tmpVal) {
        return null;
    }
    return msg;
}

//-----------------------------------------------------
//　固定電話数字チェック
//-----------------------------------------------------
function numberCheckFam(propsName: string, cf: UseFormReturn<FieldValues>){
    if (!cf.getValues(propsName)){
        return null;
    }
    //半角数字が10文字の入力・「050」で始まる11文字の入力以外の場合エラー
    const tmpVal = cf.getValues(propsName).replaceAll("-", "");
    if (tmpVal.length === 10){
        return null;
    }
    if (tmpVal.length === 11 && tmpVal.indexOf("050") === 0){
        return null;
    }
    return ConstMsg.EG0040013;
}

//-----------------------------------------------------
//　携帯電話数字チェック
//-----------------------------------------------------
function numberCheckPrivate(propsName: string, cf: UseFormReturn<FieldValues>){
    if (!cf.getValues(propsName)){
        return null;
    }
    //半角数字が「090」「080」「070」「060」で始まる11文字の入力以外の場合エラー
    const tmpVal = cf.getValues(propsName).replaceAll("-", "");
    if (tmpVal.length === 11 && (tmpVal.indexOf("090") === 0 || tmpVal.indexOf("080") === 0 || tmpVal.indexOf("070") === 0 || tmpVal.indexOf("060") === 0)) {
        return null;
    }
    return ConstMsg.EG0040012;
}

//-----------------------------------------------------
//　必須チェック
//-----------------------------------------------------
function requiredCheck(props: IFProps, cf: UseFormReturn<FieldValues>){
    if(cf.getValues(props.nameTelFam) || cf.getValues(props.nameTelPrivate)){
        return null;
    }
    return ConstMsg.EG0040011;
}